import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_18: FaireProductEntity = {
  token: "catalog_prod_prod-18",
  type: "product",
  name: "Birthday Mug - This Is My Birthday Mug - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=400&fit=crop",
  priceDollars: 11.65,
  msrpDollars: 29.13,
  sku: "CO0018",
  caseSize: 6,
  material: "Ceramic",
  collectionToken: "col_confetti-cake",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 4,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  categoryTokens: ["cat_household-all"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
